module.exports = __webpack_public_path__ + "img/logo.d8ca4d38.png";